
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  children?: React.ReactNode;
}

const FeatureCard = ({ icon: Icon, title, description, children }: FeatureCardProps) => {
  return (
    <Card className="bg-white shadow-md hover:shadow-lg transition-shadow">
      <CardHeader className="pb-2">
        <div className="bg-primary-blue/10 rounded-full w-12 h-12 flex items-center justify-center mb-4">
          <Icon className="h-6 w-6 text-primary-blue" />
        </div>
        <CardTitle className="text-xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600 mb-3">{description}</p>
        {children}
      </CardContent>
    </Card>
  );
};

export default FeatureCard;

